import React, { useContext, useEffect, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import SectionHeader from "../Atomics/SectionHeader/SectionHeader";
import TopCategoriesSlider from "./TopCategoriesSlider";
import { faEllipsisH } from "@fortawesome/free-solid-svg-icons";
import { VideosContext } from "../../context/videos";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

function TopCategory({ title, data, type }) {
  // ----------------------------------------------------Getting the channels----------------------------------------------------
  const { videos } = useContext(VideosContext);
  const [cardsToBeShown, setCardsToBeShown] = useState([]);
  const [status, setStatus] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const location = useLocation();

  useEffect(() => {
    if (data && videos) {
      if (title === "کانال ها") {
        setCardsToBeShown(data.content_items);
        setStatus(data.content_items.length > 10);
      } else {
        setCardsToBeShown(videos?.results || []);
        setStatus(false);
      }
      setIsLoading(false);
    }
  }, [data, videos, title, location]);

  if (isLoading) {
    return <div>لطفا منتظر بمانید...</div>;
  }

  return (
    <div className="top-category section-padding mb-4">
      <Row>
        <Col md={12}>
          <SectionHeader
            heading={title}
            noIconLabel
            icon={faEllipsisH}
            more={{
              status: status,
              value: "/channels",
            }}
          />
        </Col>

        <Col md={12}>
          <TopCategoriesSlider tenChannels={cardsToBeShown} title={title} type={type} />
        </Col>
      </Row>
    </div>
  );
}

export default TopCategory;
